import type { ReactNode } from 'react';
import Folha from '@/components/movimento/Folha';

interface SheetProps {
  aberto: boolean;
  titulo?: string;
  aoFechar: () => void;
  children: ReactNode;
  rodape?: ReactNode;
  /** Camada da folha no empilhamento (padrão 70, acima do menu ☰). */
  zIndex?: number;
}

// Folha do app: sobe de baixo com mola, fecha arrastando para baixo,
// com Esc, no X ou tocando fora. O conteúdo é o mesmo de sempre.
export default function Sheet({
  aberto,
  titulo,
  aoFechar,
  children,
  rodape,
  zIndex = 70,
}: SheetProps) {
  return (
    <Folha
      aberto={aberto}
      titulo={titulo}
      aoFechar={aoFechar}
      rodape={rodape}
      zIndex={zIndex}
      larguraMaxima="max-w-lg"
    >
      {children}
    </Folha>
  );
}